exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-generic-interior-js": () => import("./../../../src/templates/generic-interior.js" /* webpackChunkName: "component---src-templates-generic-interior-js" */)
}

